import { useCallback, useState } from "react";
import { Template, UpdateTemplateParams } from "../../hooks/templateV2/types";
import { Input } from "../ui/input";
import { PopoverContent } from "../ui/popover";
import { Button } from "../ui/button";
import { TrashIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PopoverClose } from "@radix-ui/react-popover";

interface UpdateTemplatePopoverProps {
  template: Template;
  updateTemplate: ({
    template,
    schemaId,
    name,
    userId,
  }: UpdateTemplateParams) => void;
}
export const UpdateTemplatePopover = ({
  template,
  updateTemplate,
}: UpdateTemplatePopoverProps) => {
  const [templateName, setTemplateName] = useState(template.name);
  const navigate = useNavigate();

  const handleDelete = useCallback(async () => {
    try {
      await updateTemplate({
        template,
        schemaId: template.id,
        name: templateName,
        userId: template?.userId || undefined,
        deleteTemplate: true,
      });
      navigate("/dashboard/templates");
    } catch (error) {
      console.error(error);
    }
  }, [template, templateName, updateTemplate, navigate]);

  const handleSave = useCallback(async () => {
    try {
      await updateTemplate({
        template,
        schemaId: template.id,
        name: templateName,
        userId: template?.userId || undefined,
      });
    } catch (error) {
      console.error(error);
    }
  }, [template, templateName, updateTemplate]);

  return (
    <PopoverContent>
      <div className="flex flex-col gap-4">
        <div className="flex justify-end">
          <TrashIcon
            className="cursor-pointer"
            onClick={handleDelete}
            size={16}
          />
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="templateName" className="text-sm">
            Template Name
          </label>
          <Input
            type="text"
            placeholder="Template Name"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
          />
        </div>
        <PopoverClose asChild>
          <Button onClick={handleSave}>Save</Button>
        </PopoverClose>
      </div>
    </PopoverContent>
  );
};
